

export function titleize(original) {
  const exclusions = ['and', 'of', 'to', 'be', 'a', 'in', 'for', 'is'];
  return original.split(' ')
    .map((s) => {
      if (exclusions.indexOf(s.toLowerCase()) !== -1) {
        return s;
      }
      return s.charAt(0).toUpperCase() + s.slice(1);
    })
    .join(' ');
}

export function capFirst(string) {
  if (!string || typeof string !== 'string') {
    return string;
  }

  return string.substring(0, 1).toUpperCase() + string.slice(1);
}



// WEBPACK FOOTER //
// ./src/lib/strings/index.js